import React, { Component } from 'react';
import classNames from 'classnames';
import { ArrowLink, Dialog } from '../../atoms';

import './styles.css';

/**
 * A dialog for error and success messages.
 *
 * @typedef {Object} Props
 * @prop {boolean} [error]
 * @prop {boolean} [visible]
 * @prop {Function} [onClose]
 * @prop {String} content
 * @prop {String} heading
 * @prop {String} href
 * @prop {String} linkLabel
 *
 * @augments {Component<Props>}
 */
export default class FormDialog extends Component {

	genClassName = ({ error }) => classNames('FormDialog', { error });

	render () {
		const { content, href, linkLabel, heading, onClose, ...props } = this.props;

		return (
			<Dialog className={this.genClassName(this.props)} {...props}>
				<div />
				<div>
					<h1>{heading}</h1>
					<p>{content}</p>
					<ArrowLink href={href} onClick={onClose} className='FormDialog-backLink'>{linkLabel}</ArrowLink>
				</div>
			</Dialog>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/molecules/FormDialog/FormDialog.js